export function addressToString(address: { street: string; city: string; state: string; zip_code: string }) {
    return `${address.street ? address.street : ''} ${address.city}, ${address.state} ${address.zip_code}`;
}
